if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");

        this._inited = false;
        this._onScroll = null;
        this._onResize = null;
      }

      connectedCallback() {
        this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductInfo = document.querySelector(".m-main-product--info");

        if (!this.container) return;

        // IMPORTANT: hidden by default (so it NEVER shows on page load)
        this.container.style.setProperty("--m-translate-y", "100%");
        document.documentElement.classList.remove("stick-atc-show");

        this.domNodes = queryDomNodes(this.selectors, this.container);

        const tryInit = () => {
          this.mainProductForm = document.querySelector(".m-product-form--main");
          if (!this.mainProductForm) return false;

          // REAL target: main ATC button (not the entire form)
          this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart") || null;

          this.mainDynamicCheckout = this.mainProductForm
            ? this.mainProductForm.querySelector(this.selectors.buyNowBtn)
            : null;

          this.disableSelectedVariantDefault =
            (this.mainProduct && this.mainProduct.dataset.disableSelectedVariantDefault === "true") || false;

          if (!this._inited) {
            this._inited = true;
            this.init();
          }
          return true;
        };

        if (tryInit()) return;

        // wait for form hydrate
        let tries = 0;
        const t = setInterval(() => {
          tries++;
          if (tryInit() || tries >= 200) clearInterval(t);
        }, 50);
      }

      disconnectedCallback() {
        // cleanup listeners
        if (this._onScroll) window.removeEventListener("scroll", this._onScroll, { passive: true });
        if (this._onResize) window.removeEventListener("resize", this._onResize);
      }

      init() {
        // If we can't find main ATC, show sticky (fallback), but this is rare
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          document.documentElement.classList.add("stick-atc-show");
          return;
        }

        this.variantData = this.getVariantData();

        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes || {};
        if (prodTitle) prodTitle.addEventListener("click", () => __scrollToTop());
        if (mainImage) mainImage.addEventListener("click", () => __scrollToTop());

        this.handleCustomFields();
        this.syncWithMainProductForm();

        // height calc (keep theme behavior)
        try {
          const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
          mql.onchange = this.setStickyAddToCartHeight.bind(this);
        } catch (e) {}
        this.setStickyAddToCartHeight();

        // ✅ core logic: show ONLY after you scroll past main ATC
        const update = () => {
          const headerHeight = (window.MinimogSettings && window.MinimogSettings.headerHeight) || 66;
          const rect = this.mainAddToCart.getBoundingClientRect();

          // "past ATC" == ATC bottom is above header area
          const pastAtc = rect.bottom <= headerHeight + 1;

          if (pastAtc) {
            this.container.style.setProperty("--m-translate-y", 0);
            document.documentElement.classList.add("stick-atc-show");
          } else {
            this.container.style.setProperty("--m-translate-y", "100%");
            document.documentElement.classList.remove("stick-atc-show");
          }
        };

        // run once on load
        update();

        // bind listeners
        this._onScroll = () => update();
        this._onResize = () => update();

        window.addEventListener("scroll", this._onScroll, { passive: true });
        window.addEventListener("resize", this._onResize);

        // Variant select in sticky (guard)
        if (this.domNodes && this.domNodes.select) {
          this.domNodes.select.addEventListener("change", (e) => {
            const { target } = e;
            const variantPicker = this.mainProduct ? this.mainProduct.querySelector("variant-picker") : null;

            const idInput = this.querySelector(this.selectors.variantIdSelect);
            const selectedVariantId = idInput ? idInput.value : null;

            this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
            this.currentVariant
              ? this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut)
              : this.toggleAddButton(true, window.MinimogStrings.unavailable);

            const selectedOption = target.options[target.selectedIndex];
            const selectedOptionIds = (selectedOption.dataset.options || "").split(",").filter((id) => id);

            if (variantPicker) {
              selectedOptionIds.forEach((optionId) => {
                const input = variantPicker.querySelector(`[data-option-value-id="${optionId}"]`);
                if (!input) return;

                const { tagName } = input;
                switch (tagName) {
                  case "OPTION": {
                    const inputParent = input.parentNode;
                    inputParent.value = input.value;
                    break;
                  }
                  case "INPUT":
                    input.checked = true;
                    break;
                }
              });
              variantPicker.dispatchEvent(new Event("change"));
            }
          });
        }
      }

      getVariantData() {
        if (this.variantData) return this.variantData;

        const jsonEl = this.container.querySelector('[type="application/json"]');
        if (!jsonEl) return (this.variantData = []);

        try {
          this.variantData = JSON.parse(jsonEl.textContent);
        } catch (e) {
          this.variantData = [];
        }
        return this.variantData;
      }

      setUnavailable() {
        const productForm = this.querySelector(".m-product-form");
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (addButton) this.toggleAddButton(true, window.MinimogStrings.unavailable);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(".m-product-form");
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text && addButtonText) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          if (addButtonText) addButtonText.innerHTML = window.MinimogStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      handleDisableSelectedVariantDefault() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        const pickerFields = this.querySelector(".m-product-option--dropdown-select");
        if (!pickerFields) return;

        pickerFields.value = "";
        this.setUnavailable();
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        if (window.MinimogSettings) window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        if (!variantInput) return;

        if (!window.MinimogEvents || !window.MinimogTheme || !MinimogTheme.pubSubEvents) return;

        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
          const isMainProduct =
            e && e.data && this.mainProduct && e.data.sectionId === this.mainProduct.dataset.sectionId;
          if (!isMainProduct) return;

          this.currentVariant = e.data.variant;

          if (this.currentVariant) {
            variantInput.value = e.data.variant.id;
            this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut);
          } else {
            variantInput.value = "";
            this.toggleAddButton(true, window.MinimogStrings.unavailable);
          }
        });
      }

      handleCustomFields() {
        if (!this.hasCustomFields) return;

        const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes || {};
        let hasCustomFieldRequired = false;

        const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
        customFields &&
          customFields.forEach((item) => {
            const field = item.querySelector(".form-field");
            if (field && field.value == "" && field.hasAttribute("required")) hasCustomFieldRequired = true;
          });

        hasCustomFieldRequired &&
          addToCart &&
          addToCart.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart && this.mainAddToCart.click());
          });

        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.mainProductInfo);
              if (missing.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                __scrollToTop(this.mainProductInfo, () => this.mainDynamicCheckout && this.mainDynamicCheckout.click());
              }
            },
            true
          );
        }

        if (foxkitBtn) {
          foxkitBtn.addEventListener("click", (e) => {
            e.preventDefault();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart && this.mainAddToCart.click());
          });
        }
      }
    }
  );
}
